import { FireBaseTicketsType } from "@/types/AdminPanelType";
import { AdminTicketType, ProductType } from "@/types/TicketType";

export const getGeneralTicketId = (ticket: ProductType): string | undefined => {

  const seasonIndex = ticket.seasons.findIndex((s) => {
    const [yearFrom, monthFrom, dayFrom] = s.date_from.split('-');
    const [yearTo, monthTo, dayTo] = s.date_to.split('-');
    const seasonTitle = `${dayFrom}/${monthFrom}/${yearFrom} - ${dayTo}/${monthTo}/${yearTo}`;

    return s.title === seasonTitle && s.tickets.some(t => t.type === 'General');
  });

  if (seasonIndex >= 0) {
    const generalTicket = ticket.seasons[seasonIndex].tickets.find(t => t.type === 'General');
    return generalTicket?.ticket_id;
  }
};

export const filterTickets = (siteData: FireBaseTicketsType) => {
  return siteData.homepage_products
    .filter(ticket => ticket.enabled && ticket.name !== 'Not Selected')
    .map((ticket) => {
      return {
        name: ticket.name,
        ids: ticket.ticket_ids
      }
    });
};

export const getTicketTitleById = (ticketId: number, allTickets: AdminTicketType[]) => {
  const ticket = allTickets.find((t) => +t.id === ticketId);
  return ticket ? ticket.title : "";
};
